/**
 * 水平拖拽
 */
import fvAnimation from "./fvAnimation"
export default class fvHorDrag extends fvAnimation {
    constructor(shape){
        super(shape,"fvHorDrag");
        this.dragingFlag = 0,
        this.orgShapePt = {
            x:0,
            y:0
        };
        this.shapeX = 0;
        this.orgPt = {
            x:0,
            y:0
        };
        this.expFunction = AsyncFunction('curData',this.expression + "=" + 'curData');
        this.min = AsyncFunction("return " + this.min);
        this.max = AsyncFunction("return " + this.max);
        this.minMoveToValue = AsyncFunction("return " + this.minMoveToValue);
        this.maxMoveToValue = AsyncFunction("return " + this.maxMoveToValue);
        this.orgShapePt.x = this.shape.x;
    }

    run(event,value){
        if(value == false) return;
        if(!this.shape.mouseState){
            this.dragingFlag = 0;
            return;
        }

        if(this.shape.mouseState && event.button == 0 || event.button == -1) {
            this.action(event,value);
        }else if(event.touches){
            this.touchAction(event,value);
        }
        super.run();
    }

    async action(event,value){
        var minValue = await this.executionScript(this.min);
        var maxValue = await this.executionScript(this.max);
        var minMoveToValueValue = await this.executionScript(this.minMoveToValue);
        var maxMoveToValueValue = await this.executionScript(this.maxMoveToValue);
        if("down" ==this.getEventType(event.type)){
            this.shapeX = this.shape.x;
            this.orgPt.x = event.offsetX;
            this.dragingFlag = 1;
        }else if("up" == this.getEventType(event.type) ||"dragend" == event.type){
            this.dragingFlag = 0;
            
        }else if("move" == this.getEventType(event.type)){
            if(this.dragingFlag == 1){
                var X = event.offsetX - this.orgPt.x;
                if(!this.shape.system){
                    this.shapeX = this.shape.x;
                }
                var curX = this.shapeX + X;
                if(curX > parseFloat(this.orgShapePt.x) + maxMoveToValueValue){
                    curX = parseFloat(this.orgShapePt.x) + maxMoveToValueValue;
                }
                if(curX < parseFloat(this.orgShapePt.x) - minMoveToValueValue){
                    curX = parseFloat(this.orgShapePt.x) - minMoveToValueValue;
                }
                this.curData = parseFloat(minValue) + (maxValue - minValue)*(parseFloat(curX - this.orgShapePt.x))/(maxMoveToValueValue - minMoveToValueValue);
                this.expFunction(this.curData);
                // if(this.shape.fctype.indexOf('Obj') >= 0){
                //     //this.expFunction(curData);
                //     if(this.shape.fctype == "fvGroupObj"){
                //         this.shape.preAnimationList["fvHorMove"].runEx(this.shape.cacheCtx);
                //     }else{
                //         this.shape.preAnimationList["fvHorMove"].run(this.shape.cacheCtx);
                //     }
                // }else{
                //     // value.domStyle.left = parseFloat(value.domStyle.left) + curData+"px";
                //     //this.expFunction(curData);
                // }
				
            }
        }
    }

    async touchAction(event,value){
        if("down" === this.getEventType(event.type)){
            this.shapeX = this.shape.x;
            this.orgPt.x = event.pageX;
            this.dragingFlag = 1;
        }else if("up" === this.getEventType(event.type) ||"dragend" == event.type){
            this.dragingFlag = 0;
            this.expFunction(this.curData);
        }else if("move" === this.getEventType(event.type)){
            if(this.dragingFlag == 1){
                var X = event.pageX - this.orgPt.x;
                var curX = this.shapeX + X;
                if(curX < parseFloat(this.orgShapePt.x) - maxMoveToValueValue)
                    curX = parseFloat(this.orgShapePt.x) - maxMoveToValueValue;
                if(curX > parseFloat(this.orgShapePt.x) - minMoveToValueValue)
                    curX = parseFloat(this.orgShapePt.x) - minMoveToValueValue;
                this.curData = parseFloat(minValue) + (maxValue - minValue)*(parseFloat(this.orgShapePt.x) - curX)/(maxMoveToValueValue - minMoveToValueValue);
                if(this.shape.fctype.indexOf('Obj') >= 0){
                    // this.expFunction(curData);
                    if(this.shape.fctype == "fvGroupObj"){
                        this.shape.preAnimationList["fvHorMove"].runEx(this.shape.cacheCtx);
                    }else{
                        this.shape.preAnimationList["fvHorMove"].run(this.shape.cacheCtx);
                    }
                }else{
                    // value.domStyle.left = parseFloat(value.domStyle.left) + curData+"px";
                    // this.expFunction(curData);
                }
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvHorDrag.js